import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { isNonEmptyString } from "../utils/validators.js";
import { InvalidParameterError } from "../utils/errors/index.js";
export function getLeaderboardInstanceById(_x) {
  return _getLeaderboardInstanceById.apply(this, arguments);
}

function _getLeaderboardInstanceById() {
  _getLeaderboardInstanceById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var request, instanceId, instance, startDate, endDate;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            request = _ref.request, instanceId = _ref.instanceId;

            if (isNonEmptyString(instanceId)) {
              _context.next = 3;
              break;
            }

            throw new InvalidParameterError(1623134909, 'Parameter "instanceId" must be a non-empty string.');

          case 3:
            _context.next = 5;
            return request({
              method: 'GET',
              path: "/api/v1/leaderboardInstances/".concat(instanceId)
            });

          case 5:
            instance = _context.sent;
            startDate = instance.startDate, endDate = instance.endDate;
            return _context.abrupt("return", _objectSpread(_objectSpread(_objectSpread({}, instance), startDate ? {
              startDate: new Date(startDate)
            } : {}), endDate ? {
              endDate: new Date(endDate)
            } : {}));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getLeaderboardInstanceById.apply(this, arguments);
}